// Avis de la fiche produit (refonte 2026), porté de src/sections/reviews-pdp.js du prototype, branché
// sur Junip : la note, la répartition et les avis du produit viennent de l'API publique Junip (clé
// du widget, posée par l'app dans chaque page). Tri, filtre et « Voir plus » se font dans la page.
// « Écrire un avis » monte le widget Junip du produit dans une fenêtre et ouvre son formulaire.
const API = 'https://api.juniphq.com/v1';
const PAGE = 8;
const VERIFIED = '<svg class="rcard__verified" viewBox="0 0 18 18" aria-label="Achat vérifié" role="img"><path d="M9 .8l2.1 1.5 2.6-.1.8 2.4 2.1 1.6-.8 2.5.8 2.5-2.1 1.6-.8 2.4-2.6-.1L9 17.2l-2.1-1.5-2.6.1-.8-2.4-2.1-1.6.8-2.5-.8-2.5 2.1-1.6.8-2.4 2.6.1z"/><path class="tick" d="M5.6 9.2l2.3 2.3 4.4-4.6"/></svg>';
const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
const decimal = n => n.toFixed(2).replace('.', ',');
const nameOf = c => c ? [c.first_name, c.last_name ? `${c.last_name.trim().charAt(0)}.` : ''].filter(Boolean).join(' ') : 'Anonyme';

function ago(iso) {
  const days = Math.max(0, Math.round((Date.now() - new Date(iso)) / 864e5));
  if (days === 0) return 'aujourd’hui';
  if (days < 31) return `il y a ${days} jour${days > 1 ? 's' : ''}`;
  const months = Math.round(days / 30.4);
  if (months < 12) return `il y a ${months} mois`;
  const years = Math.round(months / 12);
  return `il y a ${years} an${years > 1 ? 's' : ''}`;
}

function storeKey(root) {
  return document.querySelector('.junip-store-key[data-store-key]')?.dataset.storeKey || root.dataset.junipKey || '';
}

async function junip(path, key) {
  const r = await fetch(`${API}/${path}`, { headers: { 'Junip-Store-Key': key } });
  if (!r.ok) throw new Error(`Junip ${r.status}`);
  return r.json();
}

function card(r, star) {
  const stars = `<span class="rcard__stars" role="img" aria-label="${r.rating} étoiles sur 5">${Array.from({ length: 5 }, (_, i) => `<span class="${i < r.rating ? 'on' : ''}">${star}</span>`).join('')}</span>`;
  const name = nameOf(r.customer);
  const photos = (r.photo_urls || []).length ? `<div class="rcard__photos">${r.photo_urls.map((p, i) =>
    `<button class="rcard__photo" type="button" data-full="${esc(p.large)}" aria-label="Agrandir la photo ${i + 1} de ${esc(name)}"><img src="${esc(p.thumbnail)}" alt="" loading="lazy"></button>`).join('')}</div>` : '';
  const reply = r.response ? `<div class="rcard__reply"><button class="rcard__reply-btn" type="button" aria-expanded="false">⮑ 1 réponse de ${esc(r.respondent_display_name || 'OQP')}</button><p class="rcard__reply-text" hidden>${esc(r.response)}</p></div>` : '';
  return `<li class="rcard glass glass--window">
    <div class="rcard__head"><span class="rcard__name">${esc(name)}${r.verified_buyer ? VERIFIED : ''}</span><time class="rcard__date" datetime="${esc(r.created_at)}">${ago(r.created_at)}</time></div>
    ${stars}
    ${r.title ? `<h3 class="rcard__title">${esc(r.title)}</h3>` : ''}
    ${r.body ? `<p class="rcard__text">${esc(r.body)}</p>` : ''}
    ${photos}${reply}
  </li>`;
}

async function init(root) {
  const key = storeKey(root);
  const grid = root.querySelector('[data-grid]');
  const sort = root.querySelector('[data-sort]');
  const rating = root.querySelector('[data-rating]');
  const reset = root.querySelector('[data-reset]');
  const more = root.querySelector('[data-more]');
  const empty = root.querySelector('[data-empty]');
  const star = root.querySelector('template[data-star]').innerHTML;
  let reviews = [];
  let shown = PAGE;

  const list = () => {
    let rs = reviews.slice();
    if (rating.value) rs = rs.filter(r => r.rating === +rating.value);
    const recent = (a, b) => new Date(b.created_at) - new Date(a.created_at);
    if (sort.value === 'best') rs.sort((a, b) => b.rating - a.rating || recent(a, b));
    else if (sort.value === 'worst') rs.sort((a, b) => a.rating - b.rating || recent(a, b));
    else if (sort.value === 'photos') rs = rs.filter(r => (r.photo_urls || []).length).sort(recent);
    else rs.sort(recent);
    return rs;
  };
  const render = () => {
    const rs = list();
    grid.innerHTML = rs.slice(0, shown).map(r => card(r, star)).join('');
    empty.hidden = rs.length > 0;
    more.hidden = shown >= rs.length;
    reset.hidden = !rating.value && sort.value === 'recent';
  };
  [sort, rating].forEach(el => el.addEventListener('change', () => { shown = PAGE; render(); }));
  reset.addEventListener('click', () => { sort.value = 'recent'; rating.value = ''; shown = PAGE; render(); sort.focus(); });
  more.addEventListener('click', () => { shown += PAGE; render(); });

  grid.addEventListener('click', e => {
    const btn = e.target.closest('.rcard__reply-btn');
    if (btn) {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', String(open));
      btn.nextElementSibling.hidden = !open;
      return;
    }
    const photo = e.target.closest('.rcard__photo');
    if (photo) openLightbox(root, photo.dataset.full, photo);
  });

  initWrite(root);
  if (!key) return;

  try {
    const { products } = await junip(`products?filter%5Bremote_ids%5D=${root.dataset.productId}`, key);
    const p = products?.[0];
    if (!p) return;
    const total = p.rating_count || 0;
    if (total) {
      root.querySelector('[data-avg]').textContent = decimal(p.rating_average);
      root.querySelector('[data-avg-label]').setAttribute('aria-label', `${decimal(p.rating_average)} étoiles sur 5`);
      root.querySelector('[data-count]').textContent = `${total} avis`;
      root.querySelector('[data-bars]').innerHTML = [5, 4, 3, 2, 1].map(n => {
        const c = p.rating_distribution?.[n] || 0;
        return `<li class="rbar"><span class="rbar__n">${n}</span><span class="rbar__track" role="img" aria-label="${n} étoiles : ${c} avis"><span class="rbar__fill" style="--p:${(c / total * 100).toFixed(1)}%"></span></span></li>`;
      }).join('');
    }
    const data = await junip(`product_reviews?page%5Bsize%5D=100&filter%5Bproduct_ids%5D%5B%5D=${p.id}&include=customer`, key);
    reviews = data.product_reviews || [];
    root.querySelector('[data-tools]').hidden = reviews.length === 0;
    render();
  } catch (e) {
    // Junip injoignable : la note des métachamps reste affichée, sans la liste
  }
}

// Photo d'un avis en grand (<dialog> natif : focus piégé, Échap, clic sur le fond)
function openLightbox(root, src, opener) {
  const dlg = root.querySelector('[data-lightbox]');
  dlg.querySelector('.lightbox__img').src = src;
  dlg.showModal();
  const close = () => { dlg.close(); opener?.focus(); };
  dlg.querySelector('.lightbox__close').onclick = close;
  dlg.onclick = e => { if (e.target === dlg) close(); };
}

// « Écrire un avis » : le formulaire est celui du widget Junip (envoi, modération, photos). On monte le
// widget du produit hors écran, puis on clique sur son bouton « Écrire un avis » : sa fenêtre (en
// position fixe) s'ouvre par-dessus la page.
function initWrite(root) {
  const btn = root.querySelector('[data-write]');
  const host = root.querySelector('[data-write-host]');
  let mounted = false;
  btn.addEventListener('click', () => {
    if (!mounted) {
      mounted = true;
      const span = document.createElement('span');
      span.className = 'junip-product-review';
      span.dataset.productId = root.dataset.productId;
      host.append(span);
      window.Junip?.renderWidgets?.();
    }
    btn.setAttribute('aria-busy', 'true');
    const started = Date.now();
    const tryOpen = () => {
      const cta = host.querySelector('.junip-write-review-cta');
      if (cta) { btn.removeAttribute('aria-busy'); cta.click(); return; }
      if (Date.now() - started < 10000) setTimeout(tryOpen, 150);
      else btn.removeAttribute('aria-busy');
    };
    tryOpen();
  });
}

document.querySelectorAll('[data-product-reviews]').forEach(init);
